import { connect } from 'react-redux';
import Plan from '../../components/plan/Plan';
import { getEventsCalendar } from '../../actions/eventsCalendar';

const mapStateToProps = ({ eventsCalendar }) => ({
  calendarData: eventsCalendar.calendarData,
  loading: eventsCalendar.loading,
});

const mapDispatchToProps = {
  getEventsCalendar,
};

export default connect(mapStateToProps, mapDispatchToProps)(Plan);
